import React from 'react';

import LogoIcon from 'layouts/main-sidebar/LogoIcon';
import { Loader, Overlay } from 'ui';

type Props = {
  gray?: boolean;
  transparent?: boolean;
};

function RetinoLoader({ gray, transparent }: Props) {
  const color = gray ? 'text-gray-600' : 'text-brand-700';

  return (
    <Overlay inverted transparent={transparent} open onOverlayClick={() => null}>
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform">
        <div className="flex flex-col items-center">
          <div className={`flex flex-shrink-0 items-center justify-center px-6 ${color}`}>
            <div className="w-48">
              <LogoIcon />
            </div>
          </div>
          <div className="mt-8">
            <Loader size="huge" />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default RetinoLoader;
